"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlProvider = exports.defineMessages = exports.useIntl = exports.injectIntl = exports.FormattedMessage = void 0;
var react_intl_1 = require("react-intl");
Object.defineProperty(exports, "FormattedMessage", { enumerable: true, get: function () { return react_intl_1.FormattedMessage; } });
Object.defineProperty(exports, "injectIntl", { enumerable: true, get: function () { return react_intl_1.injectIntl; } });
Object.defineProperty(exports, "useIntl", { enumerable: true, get: function () { return react_intl_1.useIntl; } });
Object.defineProperty(exports, "defineMessages", { enumerable: true, get: function () { return react_intl_1.defineMessages; } });
Object.defineProperty(exports, "IntlProvider", { enumerable: true, get: function () { return react_intl_1.IntlProvider; } });
